import React, { useEffect, useState } from "react";
import { Box, Plus, Minus } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const PipeCreditsBlock = ({ userId }) => {
  const [credits, setCredits] = useState(null);
  const [n, setN] = useState(5);
  const [busy, setBusy] = useState(false);

  const change = async (add) => {
    setBusy(true);
    try {
      const r = await api.post(`/admin/users/${userId}/pipe-viz-credits`, { add });
      setCredits(r.data.credits);
      if (add) toast.success(`AI Izometria: ${r.data.credits} modelov`);
    } catch (e) { if (add) toast.error(e?.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  useEffect(() => { change(0); }, [userId]); // eslint-disable-line react-hooks/exhaustive-deps

  const amount = Math.max(1, Math.min(100, parseInt(n, 10) || 0));
  return (
    <div className="mt-3 pt-3 border-t border-zinc-800/60" data-testid="admin-pipe-credits">
      <label className="block text-[10px] font-mono uppercase tracking-wider text-zinc-500 mb-1.5 inline-flex items-center gap-1.5">
        <Box className="w-3 h-3" /> AI Izometria — modely navyše: <span className="text-amber-400" data-testid="admin-pipe-credits-value">{credits ?? "…"}</span>
      </label>
      <div className="flex gap-2">
        <input type="number" min="1" max="100" value={n} onChange={(e) => setN(e.target.value)} data-testid="admin-pipe-credits-input"
               className="w-20 bg-black border border-zinc-700 px-2 py-2 text-sm text-white font-mono" />
        <button onClick={() => change(-amount)} disabled={busy} data-testid="admin-pipe-credits-remove"
                className="px-3 py-2 text-xs border border-zinc-700 text-zinc-300 inline-flex items-center gap-1"><Minus className="w-3 h-3" /> Odobrať</button>
        <button onClick={() => change(amount)} disabled={busy} data-testid="admin-pipe-credits-add"
                className="wb-btn-primary px-3 py-2 text-xs inline-flex items-center gap-1"><Plus className="w-3 h-3" /> Pridať</button>
      </div>
    </div>
  );
};
